import { Directive, ElementRef, AfterViewInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { MatStep, MatStepHeader } from '@angular/material/stepper';

@Directive({
  selector: '[appStepperDisableStep]'
})
export class StepperDisableStepDirective implements AfterViewInit, OnChanges {

  @Input() stepper: ElementRef<HTMLInputElement>;

  @Input() disabled = true;

  stepHeader: MatStepHeader;

  constructor(private el: ElementRef, private host: MatStep) { }

  ngAfterViewInit() {
    Promise.resolve().then(() => this.disableStep());
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disabled && changes.disabled.currentValue !== changes.disabled.previousValue) {
      Promise.resolve().then(() => this.disableStep());
    }
  }

  disableStep() {
    const stepperHeaderContainer = this.stepper.nativeElement.querySelector('.mat-horizontal-stepper-header-container');
    const stepper = this.host._stepper;
    const index = stepper.steps.toArray().indexOf(this.host);
    const stepperHeader = stepperHeaderContainer?.querySelectorAll('mat-step-header')[index] as HTMLElement;
    if (stepperHeader) {
      stepperHeader.style.pointerEvents = this.disabled ? 'none' : 'auto';
    }
  }
}
